import React from "react";


import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";


import Logo from '../assets/img/logo1.png';


import { Link } from "react-router-dom";


export default function NavBarForCcAndNotification({ setDrawerOpen }) {


  
  
 
 
  return (
    <Box  sx={{ flexGrow: 1, display: "flex" }}>
      <AppBar
        position="fixed"
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, '& .MuiAppBar-root':{
          backgrounColor:"#d5e0eb" ,
            boxShadow:"none"     
        } ,boxShadow:"none",backgroundColor:"#fff",borderBottom:"3px solid rgba(0, 0, 0, 0.12)"}}
      >
        <Toolbar>
         
          <Box sx={{maxWidth:{lg:"20%" ,sm:"20%",md:"20%", xs:"45%"}}}>
            
            <Link to='/'>
            <img style={{maxWidth:"100%"}} src={Logo} alt='logo' />
            </Link>
         
            </Box>
          
        
        </Toolbar>
      </AppBar>
     
      
     
    </Box>
  );
}
